import { render, staticRenderFns } from "./examScore.vue?vue&type=template&id=259b48b6&scoped=true&"
import script from "./examScore.vue?vue&type=script&lang=js&"
export * from "./examScore.vue?vue&type=script&lang=js&"
import style0 from "./examScore.vue?vue&type=style&index=0&id=259b48b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259b48b6",
  null
  
)

export default component.exports